import React from 'react';

import { Modal as BSModal } from 'react-bootstrap';

import { useTrapFocus } from '../../hooks';

export type ModalPropsT = {
  body: React.ReactNode;
  footer: React.ReactNode;
  onHide: () => void;
  show: boolean;
  'aria-label'?: string;
  className?: string;
  scrollable?: boolean;
  title?: React.ReactNode;
};
export type ModalT = React.FC<ModalPropsT>;

export const Modal: ModalT = ({
  body,
  footer,
  scrollable,
  show,
  title,
  ...props
}) => {
  const { modalWrapper } = useTrapFocus(show);

  // Normalize react-bootstrap's modal ref into the dialog element used by useTrapFocus.
  const setModalRef = (instance: unknown): void => {
    if (instance instanceof HTMLDivElement) {
      modalWrapper.current = instance;

      return;
    }

    // React-Bootstrap Modal may pass an object handle with `dialog` instead of a raw element.
    if (
      instance
      && typeof instance === 'object'
      && 'dialog' in instance
      && (instance.dialog instanceof HTMLDivElement)
    ) {
      modalWrapper.current = instance.dialog;

      return;
    }

    modalWrapper.current = null;
  };

  const titleContent = (
    <>
      <BSModal.Header>
        <BSModal.Title>{title}</BSModal.Title>
      </BSModal.Header>
      <hr />
    </>
  );

  return show && (
    <BSModal {...props} scrollable={scrollable} show ref={setModalRef}>
      {title && titleContent}
      <BSModal.Body tabIndex={scrollable ? 0 : undefined}>{body}</BSModal.Body>
      <BSModal.Footer>{footer}</BSModal.Footer>
    </BSModal>
  );
};
